/**
 * @generated SignedSource<<1b7d96394692aeec4b33df59e6e5d9c9>>
 * @relayHash aa559a924178bbeb9a17eec6ba57beb1
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID aa559a924178bbeb9a17eec6ba57beb1

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uploadedDocument"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentType",
        "variableName": "documentType"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      },
      {
        "kind": "Variable",
        "name": "uploadedDocument",
        "variableName": "uploadedDocument"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "storeUploadedDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreUploadedDocumentMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "StoreUploadedDocumentMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "aa559a924178bbeb9a17eec6ba57beb1",
    "metadata": {},
    "name": "StoreUploadedDocumentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "fbf83777090b85a04bd6cc26e89ce84a";

export default node;
